import React, { useEffect, useState } from "react";
import { getRaeumePage } from "../lib/api";
import { Page, PageHeader, Section, SectionHead, IntroSplit, CardGrid, MediaCard } from "../components/ui";

export default function RaeumeUmgebungPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getRaeumePage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const { heroTitle, heroSubtitle, heroImage, introKicker, introTitle, introText, sectionTitle, sectionSubtitle, rooms } =
    data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader parent={{ label: "Über Uns", to: "/" }} current="Räume" title={heroTitle} subtitle={heroSubtitle} />

      <Section intro>
        <IntroSplit image={heroImage} kicker={introKicker} title={introTitle} text={introText} />
      </Section>

      <Section>
        <SectionHead title={sectionTitle} subtitle={sectionSubtitle} />

        <CardGrid cols={2}>
          {(rooms || []).map((room, i) => (
            <MediaCard
              key={room.id ?? i}
              image={room.image}
              title={room.title}
              text={room.text}
              tags={room.tags}
              mediaHeight="260px"
            />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}